<template>
    <flat-pickr ref="datePicker" v-if="dateConfig" v-model="selectedDate" class="date-picker" :config="dateConfig" :class="{ 'is-invalid': !state && state != null }" @input="dateUpdated"></flat-pickr>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css';
    import { Danish } from "flatpickr/dist/l10n/da.js";

    export default {
        components: { flatPickr },
        props: {
            value: null,
            state: null
        },
        data: () => ({
            selectedDate: [],
            dateConfig: null
        }),
        computed: {
            date: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            }
        },
        created() {
            this.dateConfig = {
                wrap: true,
                mode: "range",
                altFormat: 'j. M, Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                locale: Danish,
                weekNumbers: true,
                enableTime: false,
                onChange(val) {

                }
            }
        },
        mounted() {
            this.selectedDate = [...this.date]
        },
        methods: {
            dateUpdated(val) {
                var fp = this.$refs.datePicker.fp

                var dates = []
                fp.selectedDates.forEach(x => {
                    dates.push(fp.formatDate(x, "Y-m-d"))
                })

                if (dates.length != 1) {
                    this.date = dates
                }

            }
        },
    }
</script>

<style lang="scss">
    .date-picker {
        &[readonly] {
            background-color: #ffffff !important;
        }

        &.is-invalid + input.form-control {
            border-color: #ea5455;
        }
    }
</style>